import CogWheelIcon from "../images/CogWheelIcon.mjs";

/**
 * App icon for setting/properties action
 * @see {GlyphIcon}
 * @see {CogWheelIcon}
 */
const AppSettingIcon = class extends CogWheelIcon {}

export default AppSettingIcon;